module.exports = __webpack_public_path__ + "static/media/logo-text.b65c61d5.svg";